import * as React from "react"
import { Dispatch, SetStateAction } from "react"

interface ToolForDesignProps {
  designToolSelectedOption: { title: string } | undefined
  setDesignToolSelectedOption: Dispatch<
    SetStateAction<{ title: string } | undefined>
  >
}
export const ToolForDesign = ({
  designToolSelectedOption,
  setDesignToolSelectedOption,
}: ToolForDesignProps) => {
  const data = [
    {
      title: "Choose Tools for Design",
      options: [
        {
          title: "Figma",
        },
        {
          title: "Sketch",
        },
        {
          title: "InVision",
        },
        {
          title: "Adobe XD",
        },
        {
          title: "Adobe Photoshop",
        },
        {
          title: "Adobe Illustrator",
        },
      ],
    },
  ]
  return (
    <div className="mt-10 pt-10 container mx-auto">
      <div className="flex gap-1 justify-center">
        <h2 className="text-black lg:text-3xl text-xl font-bold text-center">
          {data[0].title}
        </h2>
        <p className="pt-2 text-black"> (Optional)</p>
      </div>
      <div className="flex justify-center">
        <form className="flex flex-wrap lg:gap-10 gap-3 items-center mt-5">
          {data[0].options.map((option, index) => (
            <div
              onClick={() =>
                setDesignToolSelectedOption(
                  designToolSelectedOption?.title === option.title
                    ? undefined
                    : option
                )
              }
              key={index}
              className="flex gap-2 items-center"
            >
              <div className="border border-[#7B68EC] rounded-full flex items-center p-1">
                <input
                  className="input-radio"
                  type="radio"
                  id={option.title}
                  value={option.title}
                  name="hire"
                  checked={designToolSelectedOption?.title === option.title}
                  readOnly
                />
              </div>
              <label className="text-black" htmlFor={option.title}>
                {option.title}
              </label>
            </div>
          ))}
        </form>
      </div>
    </div>
  )
}
